import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import ApplicationLayoutBodyNavigation from '@rio-cloud/rio-uikit/ApplicationLayoutBodyNavigation';
import SubNavigation from '@rio-cloud/rio-uikit/SubNavigation';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { NavLink, Outlet } from 'react-router-dom';

import { useRfidCards } from '@/api/cards';
import type { RfidCardType } from '@/api/schema';
import ChargingCardSidebar from '@/features/chargingCards/cards/components/ChargingCardSidebar';
import type { NavItemType } from '@/layout/AppLayout';
import PageLayout from '@/layout/PageLayout';
import { includesAny } from '@/lib/utils';
import { CHARGING_CARDS_MANAGEMENT, CHARGING_CARDS_ORDER_HISTORY } from '@/routes/Router';
import { useUserStore } from '@/stores/userStore';

const ChargingCardsPage = () => {
    const { isEligible, account } = useUserStore();
    const permissions = account?.permissions;
    const accountIsOnboarded = account?.isOnboarded;

    const subNavItems: NavItemType[] = [
        {
            key: 'chargingCards.management',
            permissions: ['emsp-cards.read'],
            route: (
                <NavLink to={CHARGING_CARDS_MANAGEMENT}>
                    <FormattedMessage id='general.subNavigation.cardManagement' />
                </NavLink>
            ),
        },
        {
            key: 'chargingCards.history',
            permissions: ['emsp-cards.write'],
            route: (
                <NavLink to={CHARGING_CARDS_ORDER_HISTORY}>
                    <FormattedMessage id='general.subNavigation.orderHistory' />
                </NavLink>
            ),
        },
    ];

    const allowedSubNavItems =
        isEligible && accountIsOnboarded ? subNavItems.filter(item => includesAny(permissions, item.permissions)) : [];

    const { refetch } = useRfidCards();
    const [selectedCard, setSelectedCard] = useState<RfidCardType | undefined>(undefined);

    const openSidebar = (card: RfidCardType) => {
        setSelectedCard(card);
    };

    const dismissSidebar = async (reloadCards: boolean) => {
        if (reloadCards) {
            await refetch();
        }
        setSelectedCard(undefined);
    };

    return (
        <>
            <ApplicationLayout.Sidebar className='right'>
                <ChargingCardSidebar card={selectedCard} open={!!selectedCard} dismiss={dismissSidebar} />
            </ApplicationLayout.Sidebar>
            <ApplicationLayout.Body
                navigation={
                    <ApplicationLayoutBodyNavigation className='has-offset'>
                        <SubNavigation navItems={allowedSubNavItems} />
                    </ApplicationLayoutBodyNavigation>
                }
                className='responsive'
            >
                <PageLayout>
                    <Outlet context={{ onOpenSidebar: openSidebar, isSidebarOpen: !!selectedCard }} />
                </PageLayout>
            </ApplicationLayout.Body>
        </>
    );
};

export default ChargingCardsPage;
